import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "remodra-btn-base",
  {
    variants: {
      variant: {
        default: "remodra-btn-primary",
        destructive: "remodra-btn-base bg-red-500 text-white hover:bg-red-600 focus:ring-red-400/30",
        outline: "remodra-btn-outline",
        secondary: "remodra-btn-secondary",
        ghost: "remodra-btn-ghost",
        link: "remodra-btn-base bg-transparent text-green-500 hover:text-green-400 underline-offset-4 hover:underline",
        // Remodra variants
        primary: "remodra-btn-primary",
        success: "remodra-btn-base bg-green-500 text-white hover:bg-green-600 focus:ring-green-400/30",
        warning: "remodra-btn-base bg-yellow-500 text-white hover:bg-yellow-600 focus:ring-yellow-400/30",
        error: "remodra-btn-base bg-red-500 text-white hover:bg-red-600 focus:ring-red-400/30",
      },
      size: {
        default: "remodra-btn-md",
        sm: "remodra-btn-sm",
        lg: "remodra-btn-lg",
        xl: "remodra-btn-xl",
        icon: "h-10 w-10 p-0 min-h-[44px] min-w-[44px] md:h-10 md:w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button"
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button, buttonVariants }
